import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './LegacyTobaccoGrade.css'
import format from '../../helpers/format'
import ReactTooltip from 'react-tooltip'

@CSSModules(Styles,{allowMultiple:false})
export default class LegacyTobaccoGrade extends Component {
  static propTypes = {
    score: PropTypes.string.isRequired,
    large: PropTypes.bool,
    legacy: PropTypes.bool,
  }
  constructor(props){
    super(props);
  }
  render() {
    const intGrade = format.tobaccoScoreAsInt(this.props.score)
    let style = format.join('grade', intGrade)
    let tip = '<div style=\'width:200px;text-align:left;white-space:normal;\'>'
    if (this.props.legacy){
      const legacyGrade = format.scoreTobaccoLegacy(this.props.score)
      style = format.join('lgrade', this.props.score)
      tip += 'As of August 2019, we\'ve updated our tobacco grades from a "five star" system to a letter grade system. This is the legacy grade the fund would have earned before the change. Visit our How it Works page to learn more about the new grades'
      tip += '</div>'
      return (
        <div
          styleName={style}
          data-multiline={true}
          data-effect='solid'
          data-html={true}
          data-tip={tip}
          data-for='lgrade-tooltip'
          data-place='bottom'
        >
          {legacyGrade}
          <ReactTooltip id='lgrade-tooltip'/>
        </div>
      )
    }
    const letterGrade = format.tobaccoScore(this.props.score)
    style = (this.props.large) ? (style + '-large') : style
    const wrapStyle = (this.props.large) ? 'grade-wrap-large' : 'grade-wrap'
    switch (letterGrade) {
      case 'A':
        tip += 'Fund is not invested in tobacco companies, and not invested in tobacco-promoting entertainment companies'
        break
      case 'B':
        tip += 'Fund is not invested in tobacco companies, but is invested in tobacco-promoting entertainment companies'
        break
      case 'F':
        tip += 'Fund is invested in tobacco companies, and may also be invested in tobacco-promoting entertainment companies'
        break
      case 'E':
        tip += 'Offered by a fund family that frequently engages the companies it invests in to push for corporate behavior towards sustainability'
        break
      default:
        tip += 'ERR'
        break
    }
    tip += '</div>'
    return (
      <div>
        <div styleName={wrapStyle}>
          <div
            styleName={style}
            data-multiline={true}
            data-effect={'solid'}
            data-html={true}
            data-tip={tip}
            data-for='grade-tooltip'
            data-place={(this.props.large)?'bottom':'left'}
          >
            { letterGrade }
          </div>
          <ReactTooltip id='grade-tooltip'/>
        </div>
      </div>
    )
  }
}

